export const schemaPelanggaran = {
    tgl: {
        presence: { allowEmpty: false, message: 'harus diisi' },
    },
    pelanggaran: {
        presence: { allowEmpty: false, message: 'harus dipilih' },
    },
}

export const schemaKonsultasi = {
    tgl_tanggapan: {
        presence: { allowEmpty: false, message: 'harus diisi' },
    },
    tanggapan: {
        presence: { allowEmpty: false, message: 'harus diisi' },
    },
}